export default "__VITE_ASSET__Bg5x5lxU__"